export default [ 'scorecard-line', 'scorecard-light-bands', 'scorecard-dark-bands' ]
